import React from 'react';

import logo from './../assets/Logo.png';
import '../Styles/AdminNavbar.css';

import { useAdmin } from '../Context/AdminContext';

const AdminNavbar = () => {
    const { toggleSidebar } = useAdmin();

    return (
        <nav className="admin-navbar">
            <div className="admin-navbar-left">
                <button className="sidebar-toggle-btn" onClick={toggleSidebar}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                </button>
                <div className="admin-navbar-logo-container">
                    <img
                        src={logo}
                        alt="Mégara"
                        className="admin-navbar-logo"
                    />
                </div>
            </div>

            <div className="admin-navbar-right">
                <div className="admin-user-profile">
                    <div style={{ textAlign: 'right' }}>
                        <div className="admin-name">Admin</div>
                        <div className="admin-sub">Mégara</div>
                    </div>
                    <div className="admin-avatar">A</div>
                </div>
            </div>
        </nav>
    );
};

export default AdminNavbar;
